const notificationSubDirectory = "/v1/Notifications";

export const getNotifications = `${notificationSubDirectory}/GetNotifications`;
